exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatarImg[data-v-1111f37c] {\n  height: 40px;\n}\n.my-box .el-row[data-v-1111f37c] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-1111f37c]:last-child {\n    margin-bottom: 0;\n}\n.my-box .el-col[data-v-1111f37c] {\n  border-radius: 4px;\n}\n.my-box .my-input[data-v-1111f37c] {\n  max-width: 209px;\n}\n.checkBox[data-v-1111f37c] {\n  display: inline-block;\n  width: 28%;\n}\n", ""]);

// exports
